import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import { Button, Column, Icon, Row, Select } from '@pella/sash-framework';
import { isValidArray } from '../../../utilities/validations';
import { filterContentByTags } from '../../../utilities/functions';

const ProjectGalleryFilters = ({ productType, projects, setProjects, className }) => {
	const { filter_groups } = useStaticQuery(query).contentstackCategoryInspirationConfig;
	const [activeFilters, setActiveFilters] = useState({ product: [], color: [], room: [], shape: [], style: [] });
	const [showFilters, setShowFilters] = useState(false);

	const filterOptions = filter_groups?.find((group) => group.filter_tag?.[0]?.toLowerCase() === productType?.toLowerCase())?.group;

	const onMobileButtonClick = () => setShowFilters(!showFilters);

	const onFilterChange = (tag, type) => {
		let filterProjectsByTag = [];
		let activeTags = { ...activeFilters };

		activeTags[type] = tag !== '' ? tag?.split(', ') : [];

		if (isValidArray(Object.values(activeTags)?.filter((filter) => isValidArray(filter)))) {
			Object.values(activeTags)
				.filter((filter) => isValidArray(filter))
				.forEach((filter, index) => {
					const array = index === 0 ? projects : filterProjectsByTag;
					filterProjectsByTag = filterContentByTags(filter, array, false);
				});
		} else {
			filterProjectsByTag = projects;
		}

		setActiveFilters({ ...activeFilters, [type]: tag !== '' ? tag?.split(',') : [] });
		setProjects(filterProjectsByTag);
	};

	return (
		<div
			className={`projectGalleryFilters relative ${className || ''}`}
			data-testid='project-gallery-filters'
		>
			<Button
				color='secondary'
				className='gap-2 md:!hidden'
				onClick={onMobileButtonClick}
			>
				<Icon
					name='filter_list'
					size={20}
				/>
				Project Filters
			</Button>

			<div
				className={`absolute z-3 w-full border border-t-0 max-md:border-black max-md:bg-gray-3 max-md:p-4 md:relative md:border-0 ${showFilters ? '' : 'max-md:hidden'}`}
				data-testid='project-gallery-filter-popout'
			>
				{isValidArray(filterOptions) && (
					<Row>
						{filterOptions.map((filter, index) => (
							<Column
								xs={12}
								md='fluid'
								xl='fluid'
								className='xl:!max-w-4/12'
								key={index}
							>
								<Select
									id={`gallery-${filter.category}`}
									labelText={filter.category}
									onChange={(event) => {
										onFilterChange(event.target.value, filter.category?.toLowerCase());
										onMobileButtonClick();
									}}
									value={activeFilters?.[filter.category.toLowerCase()]?.join(',') || ''}
								>
									<option value=''>All</option>
									{filter.filters.map((option, index) => (
										<option
											key={index}
											value={option.filter_tag}
										>
											{option.display_name}
										</option>
									))}
								</Select>
							</Column>
						))}
					</Row>
				)}
			</div>
		</div>
	);
};

ProjectGalleryFilters.propTypes = {
	productType: PropTypes.string,
	projects: PropTypes.array,
	setProjects: PropTypes.func,
	className: PropTypes.string,
};

export default ProjectGalleryFilters;

export const query = graphql`
	{
		contentstackCategoryInspirationConfig {
			filter_groups {
				filter_tag
				group {
					category
					filters {
						filter_tag
						display_name
					}
				}
			}
		}
	}
`;
